export const TOP_BUCKETS_LIMIT = 10
export const MAX_LABEL_LENGTH = 10
export const OTHERS_BUCKET_NAME = 'Others'

export const CHART_MARGINS = {
  top: 15,
  bottom: 85,
  left: 30,
  right: 20,
} as const

export const CHART_CONFIG = {
  keys: ['score'],
  indexBy: 'bucket',
  enabledGridY: true,
  maxValue: 'auto' as const,
}

export const SPINNER_CONFIG = {
  height: 's400' as const,
  paddingTop: 's140' as const,
}
